import React from 'react';
import { observer } from 'mobx-react-lite';
import { DefaultQueryParams, isMobile, parseQuery, useTranslation } from '@pascal/pascal-core';
import { useLocation } from 'react-router-dom';
import { gameStore } from '../../store/gameStore';
import { doBetStore } from '../../store/doBetStore';
import { cardsStore } from '../../store/cardsStore';
import { TURBO_GAME_ID } from '../../enums/constants';

export const BetHelper = observer(() => {
  const { isBetsClosed, isNotification, notificationText } = gameStore;
  const { betsModels } = doBetStore;
  const { isShuffle, burnedCards } = cardsStore;
  const { search } = useLocation();
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(search);
  const isTurbo = +gameId === TURBO_GAME_ID;
  const t = useTranslation();

  if (burnedCards.length) {
    return null;
  }

  return (
    <div className={`place-bets-text-cont ${isTurbo && !isMobile() ? 'turbo' : ''}`}>
      <span className='place-bets-text'>
        {isNotification && !isShuffle && t(notificationText)}
        {isBetsClosed &&
          !betsModels.length &&
          !isNotification &&
          !isShuffle &&
          t('WAIT_FOR_NEXT_ROUND')}
        {!isBetsClosed && !isShuffle && t('PLACE_YOUR_BETS')}
      </span>
    </div>
  );
});
